export default __webpack_public_path__ + "static/stadtamthall.logo-f14aa8499162c167cdf969b72f675b10.png";